import axios from "axios";
import { BASE_URL } from "./baseUrls";
import { CARDS_API_URL } from "./urlMetaData";
import {
  InterceptorResponseHandler,
  InterceptorResponseErrorHandler,
  InterceptorRequestHandler,
} from "./InterceptorHandler";
import secureLocalStorage from "react-secure-storage";
import { AUTH_LOCAL_VARIABLES } from "../store/features/authSlice";

const CardService = axios.create({ baseURL: BASE_URL.CARD });

CardService.interceptors.request.use((req) => InterceptorRequestHandler(req));

// Dynamically, setting baseURL based on active region
CardService.interceptors.request.use((config) => {
  const REGION = secureLocalStorage.getItem(AUTH_LOCAL_VARIABLES.REGION);
  if (!REGION) return config;
  config.baseURL = BASE_URL[REGION].CARD;
  return config;
});

CardService.interceptors.response.use(
  (res) => {
    InterceptorResponseHandler(res);
    return res;
  },
  (error) => {
    InterceptorResponseErrorHandler(error);
    return error;
  }
);

export const fetchCardList = async ({
  clientUserHashId = "",
  dateRange = "",
  page = 0,
  size = 10,
  filters,
}) => {
  const res = await CardService.post(CARDS_API_URL.CARDS_FILTER_LIST, {
    dateRange: dateRange,
    page,
    size,
    clientUserHashId,
    ...filters,
  });
  return res.data;
};

export const transferFund = async (payload) => {
  return await CardService.post(`${CARDS_API_URL.CARD_LOAD}`, payload);
};

export const fetchCardLoadReport = async ({
  userHashId = "",
  dateRange = "",
  page = 0,
  size = 10,
  userType,
  filters,
}) => {
  const res = await CardService.post(CARDS_API_URL.CARD_LOAD_REPORT, {
    dateRange: dateRange,
    page,
    size,
    fromUserHashId: userHashId,
    report: true,
    userType,
    ...filters,
  });
  return res.data;
};

export const fetchCardReqList = async ({
  userHashId = "",
  dateRange = "",
  page = 0,
  size = 10,
  filters,
}) => {
  const res = await CardService.post(CARDS_API_URL.CARD_LOAD_REPORT, {
    dateRange: dateRange,
    page,
    size,
    ownerHashId: userHashId,
    report: false,
    ...filters,
    status: "Requested",
  });
  return res.data;
};

export const fetchTransferHistory = async ({
  userHashId = "",
  userType = "",
  customerHashId = "",
}) => {
  const res = await CardService.post(`${CARDS_API_URL.TRANSFER_HISTORY}`, {
    report: "true",
    fromUserHashId: userHashId,
    userType,
    customerHashId,
  });
  return res.data;
};

export const fetchCardLoadReqStats = async ({ userHashId = "" }) => {
  const res = await CardService.get(
    `${CARDS_API_URL.CARD_LOAD_REQS_COUNT}/${userHashId}`
  );
  return res.data;
};

export const BulkOperationCard = async ({ payload }) => {
  const res = await CardService.post(
    `${CARDS_API_URL.BULK_OPERATION}`,
    payload
  );
  return res.data;
};

export const fetchBulkDetailedSummary = async (payload) => {
  const res = await CardService.post(
    `${CARDS_API_URL.BULK_DETAILED_SUMMARY}/${payload.category}`,
    payload
  );
  return res.data;
};

export default CardService;
